import { AppText, AppIcon } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppBaseScreen from "@toothfairy/shared-ui/AppBaseScreen";
import AppChoice from "@toothfairy/shared-ui/AppChoice";
import AppPlaceholderView from "@toothfairy/shared-ui/AppPlaceholderView";
import AppQuantumChat from "@toothfairy/shared-ui/AppQuantumChat";
import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppUser from "@toothfairy/shared-ui/AppUser";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Popable } from "react-native-popable";
import { Platform, View, useWindowDimensions } from "react-native";
import AppJoyRide from "../../Components/Joyride";
import LoadingPlaceholder from "../../Components/LoadingPlaceholder";
import ToothFairyButton from "../../Components/ToothFairyComponents/ToothFairyButton";
import ToothFairyClickableOption from "../../Components/ToothFairyComponents/ToothFairyClickableOption";
import ToothFairyModal from "../../Components/ToothFairyComponents/ToothFairyModal";
import ToothFairyResponsiveOptionsModal from "../../Components/ToothFairyComponents/ToothFairyResponsiveOptionsModal";
import ToothFairySupportButton from "../../Components/ToothFairyComponents/ToothFairySupportButton";
import AppTreeView from "../../Components/TreeView";
import useUserHelperPreferences from "../../Hooks/useUserHelperPreferences";
import useWorkspaces from "../../Hooks/useWorkspaces";
import { useHistory } from "../../Router";
import {
  isLargeScreen,
  isMobileScreen,
  minAppWidth,
} from "../MainViewContainer";
import TopicsSelectionComponent from "../MrcDocuments/Components/TopicsSelectionComponent";
import ChatCreationForm from "./Components/ChatCreationForm";
import ChatWebInput from "./Components/ChatWebInput";
import ReferencesView from "./Components/ReferencesView";
import Utility from "../../Utility";
import {
  isConnectedToCloud,
  isElectronRunning,
  oLlamaModelLoaded,
} from "../../../App";
import { _baseModels } from "../Settings/Components/QA/SubComponents/QaSettingsAIView";
const steps_first_interaction = [
  {
    disableBeacon: true,
    target: ".upload_docs",
    content:
      "You can start chatting with your docs by uploading them to the Knowledge Hub.",
    placement: "right",
  },
];

const steps_second_interaction = [
  {
    disableBeacon: true,
    target: ".start_chat",
    content:
      "Once you have uploaded your docs and the learning process is complete, you can start chatting with them.",
    placement: "left",
  },
];

const ChatsScreenView = ({
  handleClickOnNode,
  SaveChat,
  selectedNode,
  deleteNode,
  showModal,
  setShowModal,
  setDialogActionOnTree,
  treeViewActionContext,
  isTreeDataLoading,
  selectedTopics,
  onSelectedTopicsChange,
  topics,
  onDrop,
  _coreTreeViewData,
  selectedNodeToDelete,
  creationofNewDocumentInProgress,
  isCollapsed,
  setIsCollapsed,
  onMove,
  chatId,
  primaryAgent,
  isLoading,
  messages,
  setMessages,
  onLoadEarlier = () => {},
  chatObject,
  isAIStreaming,
  isAIReplyingOtherUsers,
  onCancelGeneration = () => {},
  onSendEvent = () => {},
  handleShowSourcesDetails = () => {},
  handleParentActionClick = () => {},
  handleFeedback = () => {},
  handleClickOnWidgetChatsHistory = () => {},
  listenToAudio = () => {},
  inputText,
  setInputText,
  allMessagesLoaded,
  subscriptionObj,
  streamingMessageID,
  documents,
  documentId,
  setTreeViewActionContext,
  S3downloadUrlRequest,
  workspaceid,
  errorWithSubscription,
  handleCopy = () => {},
  showSourcesModal,
  setShowSourcesModal,
  selectedSources,
  isMoreToLoad,
  creationOfNewChatInProgress,
  allowStop = false,
  setIsChatHistoryLoaded,
  isLastMessageEmpty,
  showWidgetChatsHistory,
  setShowWidgetChatsHistory,
  canInteractWithChat,
  onImageUploaded,
  imageUrl,
  setImageUrl,
  onAudioUploaded,
  audioUrl,
  setAudioUrl,
  onFileUploaded,
  fileUrl,
  setFileUrl,
  onVideoUploaded,
  videoUrl,
  setVideoUrl,
  onImageSelected = () => {},
  selectedImageKey,
  onFilesUploaded = () => {},
  fileUrls,
  setFileUrls,
  forceAgentsName,
  activeStep,
  planningExecution,
  totalSteps,
  setSelectedNode,
  isSpeechGettingProcessed,
  updateTextForSpeech = () => {},
  stopAudio = () => {},
  isPlaying,
  lastUpdateMessageTime,
  agentHosting,
  planArtifacts,
  cursor,
  isFeedbackOnPlanAllowed,
  isSocketConnected,
  updatePlanApprovalState,
}) => {
  const formRef = useRef();
  const { state, dispatch } = AppStateManager.useAppStateManager();
  const [agentImage, setAgentImage] = useState(null);
  const history = useHistory();
  const { currentTheme } = AppTheme.useTheme();
  const [isModalOptionsOpen, setIsModalOptionsOpen] = useState(false);
  const [isTopicModalOpen, setIsTopicModalOpen] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [isPlannerModalShown, setShowPlannerModal] = useState(false);
  const [isArtifactsModalShown, setShowArtifactsModal] = useState(false);
  const { user } = AppUser.useUser();
  const { updateUserHelperPreferences } = useUserHelperPreferences();
  const { getActiveWorkspace, loadChats, getPlanConfig, isUserContentAdmin } =
    useWorkspaces();
  const { height } = useWindowDimensions();
  const _selectedNodeType = selectedNode?.data?.droppable ? "node" : "chat";
  const fetchAgentImage = async (workspaceid) => {
    const _url = await S3downloadUrlRequest({
      filename: `imported-image/${workspaceid}/${primaryAgent?.icon}`,
      context: "pdf",
      workspaceid,
    });
    setAgentImage(_url?.url);
  };
  const fetchStepArtifact = async (key) => {
    const _url = await S3downloadUrlRequest({
      filename: key,
      context: "pdf",
      workspaceid,
    });
    if (isElectronRunning())
      window.electronAPI.downloadFileDl(_url?.url, "_blank");
    else window.open(_url?.url, "_blank");
  };

  useEffect(() => {
    if (primaryAgent?.icon && workspaceid) fetchAgentImage(workspaceid);
    else {
      setAgentImage(null);
    }
  }, [primaryAgent?.icon, workspaceid]);
  useEffect(() => {
    if (!showModal) {
      formRef?.current?.resetForm();
      setShowModal(false);
      setTreeViewActionContext("");
    }
  }, [showModal]);
  const getAgentObject = (agentId) => {
    return state?.agents?.find((u) => u.id == agentId);
  };
  function sanitizeString(inputString) {
    // Step 1: Remove ```mermaid ``` clauses
    const mermaidRegex = /```mermaid[\s\S]*?```/g;
    let sanitizedString = inputString.replace(mermaidRegex, "");

    // Step 2: Replace markdown image tags with ![image]
    const imageRegex = /!\[tf_image\]\([^)]+\)/g;
    sanitizedString = sanitizedString.replace(imageRegex, "![image]");

    return sanitizedString;
  }
  const createMessagesExportFile = () => {
    // using getSiteObject()?.siteTree generate a txt file and allow the user to download it
    const element = document.createElement("a");
    const file = new Blob(
      [
        JSON.stringify(
          messages?.map((u) => {
            return {
              id: u?._id,
              user: u?.user,
              text: sanitizeString(u?.text),
              createdAt: u?.createdAt,
            };
          }),
          undefined,
          4
        ),
      ],
      {
        type: "text/plain;charset=utf-8",
      }
    );
    element.href = URL.createObjectURL(file);
    element.download = `${chatId}-messages-export.txt`;
    document.body.appendChild(element);
    element.click();
  };
  const mapModeWithLabel = (mode) => {
    switch (mode) {
      case "planner":
        return "Orchestrator";
      case "chatter":
        return "Assistant";
      case "coder":
        return "Programmer";
      case "retriever":
        return "Operator";
      case "computer":
        return "Desktop";
      default:
        return "Unknown";
    }
  };
  const getAgentDescription = (agent) => {
    return `${agent?.label} - ${mapModeWithLabel(agent?.mode)}`;
  };

  const constructToolsListForAgentTools = (
    primaryAgent,
    agentHosting,
    chatObject
  ) => {
    const tools = [];

    if (chatObject?.handedOffToHuman) {
      return [{ icon: "human", description: "Human handoff - agent disabled" }];
    }

    if (agentHosting?.type == "ollama") {
      return [
        { icon: "ollama", description: "Ollama hosting - no tools available" },
      ];
    }

    if (primaryAgent?.mode == "planner") {
      const agentCount = primaryAgent?.agentsPool?.length || 0;
      const canAutoSpawn = primaryAgent?.plannerAutoAgentSpawn === true;

      if (agentCount === 0) {
        if (canAutoSpawn) {
          tools.push({
            icon: "planner-auto",
            description: "Can dynamically generate agents",
          });
        } else {
          tools.push({
            icon: "planner-empty",
            description: "No agents available",
          });
        }
      } else {
        const agentText = agentCount === 1 ? "agent" : "agents";
        let description = `Access to ${agentCount} ${agentText}`;

        if (canAutoSpawn) {
          description += " + dynamic generation";
        }

        tools.push({ icon: "planner", description });
      }
    } else {
      if (
        primaryAgent?.hasTopicsContext &&
        primaryAgent?.allowedTopics?.length > 0
      ) {
        tools.push({ icon: "notes", description: "Knowledge hub" });
      }

      if (primaryAgent?.agentFunctions?.length > 0) {
        tools.push({ icon: "functions", description: "Functions" });
      }

      if (primaryAgent?.allowInternetSearch) {
        tools.push({ icon: "internet", description: "Internet search" });
      }

      if (primaryAgent?.mode == "computer") {
        tools.push({ icon: "desktop", description: "Virtual desktop" });
      }

      if (primaryAgent?.hasCode) {
        tools.push({ icon: "code", description: "Code execution" });
      }

      if (primaryAgent?.allowImagesGeneration) {
        tools.push({ icon: "image-gen", description: "Image generation" });
      }

      if (primaryAgent?.allowVideosGeneration) {
        tools.push({ icon: "video-gen", description: "Video generation" });
      }

      if (primaryAgent?.allow3dModelGeneration) {
        tools.push({ icon: "3d-gen", description: "3D model generation" });
      }
      if (chatObject?.visibility === "private")
        tools.push({ icon: "private", description: "Private conversation" });
      if (chatObject?.visibility === "public")
        tools.push({ icon: "users", description: "Public conversation" });
    }

    return tools.length > 0
      ? tools
      : [{ icon: "no-tools", description: "No tools available" }];
  };

  function getLeftIcon(type, AppAssets) {
    // Map file extensions to types
    const extensionToTypeMap = {
      // Audio files
      mp3: "audio",
      wav: "audio",
      ogg: "audio",
      m4a: "audio",

      // Video files
      mp4: "video",
      avi: "video",
      mov: "video",
      wmv: "video",

      // Programming files
      html: "programming",
      css: "programming",
      js: "programming",
      py: "programming",
      java: "programming",
      cpp: "programming",

      // Spreadsheet files
      xlsx: "spreadsheet",
      xls: "spreadsheet",
      csv: "spreadsheet",

      // Document files
      doc: "document",
      docx: "document",
      pdf: "document",
      txt: "document",

      // Presentation files
      ppt: "presentation",
      pptx: "presentation",

      // Image files (you might want to add an 'image' type to your iconMap)
      jpg: "image",
      jpeg: "image",
      png: "image",
      gif: "image",
      svg: "image",
    };

    // Get the file type based on extension
    const fileType = extensionToTypeMap[type] || "unknown";
    const iconMap = {
      audio: AppAssets?.icons?.audio,
      video: AppAssets?.icons?.video,
      programming: AppAssets?.icons?.html,
      spreadsheet: AppAssets?.icons?.spreadsheet,
      document: AppAssets?.icons?.document,
      presentation: AppAssets?.icons?.presentation,
      image: AppAssets?.icons?.image,
    };

    return iconMap[fileType] || AppAssets?.icons?.file;
  }

  function getFileNameAndExtension(path) {
    // Check if the input is a non-empty string
    if (typeof path !== "string" || path.trim() === "") {
      return { fileName: "", extension: "" };
    }

    // Split the path by '/' and get the last part
    const parts = path.split("/");
    const lastPart = parts[parts.length - 1];

    // Split the last part by '.' to separate filename and extension
    const fileParts = lastPart.split(".");

    // If there's no extension, return the whole filename
    if (fileParts.length === 1) {
      return { fileName: lastPart, extension: "" };
    }

    // Get the extension (last part after the dot)
    const extension = fileParts.pop();

    // Join the remaining parts as the filename
    const fileName = fileParts.join(".");

    return { fileName, extension, fullName: lastPart };
  }

  const _artifactsModalView = useMemo(() => {
    return (
      <ToothFairyModal
        transparent
        modalStyle={
          Platform.OS === "web"
            ? {
                width: "95%",
                maxWidth: 600,
                height: "auto",
                marginHorizontal: "auto",
                marginTop: "auto",
                marginBottom: "auto",
                borderRadius: 20,
                maxHeight: "99%",
              }
            : {}
        }
        isModalVisible={isArtifactsModalShown}
        animationType="none"
        modalBackdrop={currentTheme?.theme?.softBackgroundColor}
        isCloseButtonVisible
        modalTitle={"Artifacts available"}
        modalInnerContentStyle={{
          paddingHorizontal: 20,
          paddingVertical: 20,
        }}
        closeModal={() => {
          setShowArtifactsModal(false);
        }}
      >
        <View
          style={{
            gap: 5,
          }}
        >
          {planArtifacts?.map((artifact) => {
            const { fileName, extension, fullName } = getFileNameAndExtension(
              artifact?.file_key
            );
            return (
              <AppText
                wrapperStyle={{
                  alignItems: "flex-start",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  gap: 5,
                  paddingVertical: 5,
                }}
                iconSize={16}
                leftIcon={getLeftIcon(extension, AppAssets)}
                key={artifact?.file_key}
                // rightIcon={AppAssets?.icons?.goTo}
                onPress={() => {
                  fetchStepArtifact(artifact?.file_key);
                }}
                isClickable
              >
                {`File name: ${fullName}\nStep definition: ${artifact?.description_from_step_definition}`}
              </AppText>
            );
          })}
        </View>
      </ToothFairyModal>
    );
  }, [
    setShowArtifactsModal,
    isArtifactsModalShown,
    JSON.stringify(planArtifacts),
  ]);

  const _plannerModalView = useMemo(() => {
    return (
      <ToothFairyModal
        transparent
        modalStyle={
          Platform.OS === "web"
            ? {
                width: "95%",
                maxWidth: 600,
                height: "auto",
                marginHorizontal: "auto",
                marginTop: "auto",
                marginBottom: "auto",
                borderRadius: 20,
              }
            : {}
        }
        isModalVisible={isPlannerModalShown}
        animationType="none"
        modalBackdrop={currentTheme?.theme?.softBackgroundColor}
        isCloseButtonVisible
        modalTitle={"Agents available"}
        modalInnerContentStyle={{
          paddingHorizontal: 20,
          paddingVertical: 20,
        }}
        closeModal={() => {
          setShowPlannerModal(false);
        }}
      >
        <View
          style={{
            gap: 5,
          }}
        >
          {primaryAgent?.agentsPool?.map((agent) => {
            const _agent = getAgentObject(agent);
            return (
              <AppText
                wrapperStyle={{
                  alignItems: "center",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  gap: 5,
                  paddingVertical: 5,
                }}
                iconSize={16}
                leftIcon={Utility.mapAgentTypeWithIcon(_agent, AppAssets)}
                key={agent}
                rightIcon={AppAssets?.icons?.goTo}
                onRightIconPress={() => {
                  history.push(
                    `/workspaces/${
                      getActiveWorkspace()?.id
                    }/settings/roles_settings/${agent}`
                  );
                }}
              >
                {getAgentDescription(_agent)}
              </AppText>
            );
          })}
        </View>
      </ToothFairyModal>
    );
  }, [setShowPlannerModal, isPlannerModalShown]);

  const _coreModalView = useMemo(() => {
    const handleFormSubmit = (values) => {
      if (treeViewActionContext === "NEW_CHAT") SaveChat({}, values, false);
      else if (treeViewActionContext === "EDIT_CHAT")
        SaveChat(selectedNode, values, true);
    };
    const generateModalTitle = () => {
      if (treeViewActionContext === "NEW_CHAT") return "New Chat";
      else if (treeViewActionContext === "EDIT_CHAT") return "Edit chat";
    };
    return (
      <ToothFairyModal
        transparent
        modalStyle={
          Platform.OS === "web"
            ? {
                width: "95%",
                maxWidth: 600,
                height: "auto",
                marginHorizontal: "auto",
                marginTop: "auto",
                marginBottom: "auto",
                borderRadius: 20,
              }
            : {}
        }
        isModalVisible={showModal}
        animationType="none"
        modalBackdrop={currentTheme?.theme?.softBackgroundColor}
        isCloseButtonVisible
        modalTitle={generateModalTitle()}
        modalInnerContentStyle={{
          paddingHorizontal: 20,
          paddingVertical: 20,
        }}
        closeModal={() => {
          formRef?.current?.resetForm();
          setShowModal(false);
          setTreeViewActionContext("");
        }}
      >
        {treeViewActionContext === "DELETE_NODE" ? (
          <AppChoice
            wrapperStyle={{
              alignSelf: "center",
              maxWidth: 600,
              marginTop: 50,
            }}
            cancelCaption={`${_selectedNodeType}DeleteCancelCaption`}
            confirmCaption={`${_selectedNodeType}DeleteConfirmCaption`}
            onConfirmButtonPress={() => {
              deleteNode(selectedNodeToDelete);
            }}
            onCancelButtonPress={() => {
              setShowModal(false);
            }}
            AppChoiceButton={ToothFairyButton}
            caption={`${_selectedNodeType}DeleteCaption`}
            subCaption={`${_selectedNodeType}DeleteSubCaption`}
          />
        ) : (
          <ChatCreationForm
            ref={formRef}
            creationofNewDocumentInProgress={creationofNewDocumentInProgress}
            treeViewActionContext={treeViewActionContext}
            selectedNode={selectedNode}
            handleFormSubmit={handleFormSubmit}
            documents={documents}
          />
        )}
      </ToothFairyModal>
    );
  }, [
    setShowModal,
    SaveChat,
    // createDocument,
    currentTheme,
    showModal,
    isLargeScreen(),
    selectedNode?.id,
    treeViewActionContext,
    creationofNewDocumentInProgress,
    documents?.length,
  ]);

  const _coreSourcesModelView = useMemo(() => {
    return (
      <ToothFairyModal
        transparent
        modalStyle={
          Platform.OS === "web"
            ? {
                width: "95%",
                maxWidth: 600,
                maxHeight: "99%",
                minHeight: 300,
                height: "auto",
                marginHorizontal: "auto",
                marginTop: "auto",
                marginBottom: "auto",
                borderRadius: 20,
              }
            : {}
        }
        isModalVisible={showSourcesModal}
        animationType="none"
        modalBackdrop={currentTheme?.theme?.softBackgroundColor}
        isCloseButtonVisible
        modalTitle={"Tools details"}
        modalInnerContentStyle={{
          paddingHorizontal: 20,
          paddingVertical: 20,
        }}
        closeModal={() => {
          setShowSourcesModal(false);
        }}
      >
        <ReferencesView selectedSources={selectedSources} />
      </ToothFairyModal>
    );
  }, [JSON.stringify(selectedSources), showSourcesModal]);

  const topicSelectionComponent = useMemo(() => {
    return (
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          paddingVertical: !isMobileScreen() && 10,
          zIndex: 1,
          marginLeft: 10,
          minWidth: "50%",
          flex: 1,
          // overflowX: "hidden",
        }}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            gap: 10,
          }}
        >
          <Popable
            numberOfLines={3}
            backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
            style={[
              {
                top: 30,
                zIndex: 20,
                maxWidth: 400,
              },
            ]}
            content={`Agent name: ${primaryAgent?.label}`}
            action="hover"
            position="left"
          >
            <AppText
              style={{
                fontWeight: "bold",
              }}
              color={currentTheme?.theme?.darkGrey}
            >
              {primaryAgent?.label}
            </AppText>
          </Popable>

          <AppText
            style={{
              fontWeight: "bold",
            }}
            color={currentTheme?.theme?.darkGrey}
            wrapperStyle={{
              marginHorizontal: 10,
            }}
          >
            |
          </AppText>
          {constructToolsListForAgentTools(
            primaryAgent,
            agentHosting,
            chatObject
          )?.map((u) => {
            return (
              <Popable
                numberOfLines={3}
                backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
                style={[
                  {
                    top: 30,
                    zIndex: 20,
                    maxWidth: 400,
                  },
                ]}
                content={u?.description}
                action="hover"
                position="left"
              >
                <AppIcon
                  wrapperStyle={{
                    cursor: "pointer",
                  }}
                  color={currentTheme?.theme?.orange}
                  icon={AppAssets?.icons[u?.icon]}
                  size={16}
                />
              </Popable>
            );
          })}
        </View>
        <AppText
          style={{
            fontWeight: "bold",
          }}
          color={currentTheme?.theme?.darkGrey}
          wrapperStyle={{
            marginHorizontal: 10,
          }}
        >
          |
        </AppText>
        {primaryAgent?.mode == "planner" &&
          planningExecution != "plan_execution_completed" &&
          planningExecution != "plan_execution_failed" &&
          planningExecution != "step_requires_approval" &&
          totalSteps > 0 &&
          activeStep > 0 && (
            <Popable
              numberOfLines={2}
              backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
              style={[
                {
                  top: 30,
                  zIndex: 20,
                  maxWidth: 300,
                },
              ]}
              content={`Running step ${activeStep || 1}`}
              action="hover"
              position="left"
            >
              <AppText
                style={{
                  fontWeight: "bold",
                }}
                color={currentTheme?.theme?.primary}
                preventTranslation
                rightIcon={AppAssets?.icons?.plannerStep}
                iconSize={16}
                wrapperStyle={{
                  marginRight: 20,
                }}
              >
                {" "}
                {activeStep || 1}
              </AppText>
            </Popable>
          )}
        {planArtifacts?.length > 0 && (
          <Popable
            numberOfLines={2}
            backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
            style={[
              {
                top: 30,
                zIndex: 20,
                maxWidth: 300,
              },
            ]}
            content={"Show artifacts"}
            action="hover"
            position="left"
          >
            <AppIcon
              wrapperStyle={{
                marginRight: 10,
              }}
              isClickable
              onPress={() => {
                setShowArtifactsModal(true);
              }}
              style={{
                fontSize: currentTheme?.theme?.extra_small_font_size,
                fontWeight: "bold",
                color: currentTheme?.theme?.darkGrey,
                marginLeft: 5,
                textDecorationColor: currentTheme?.theme?.darkGrey,
              }}
              icon={AppAssets?.icons?.artifacts}
              color={currentTheme?.theme?.darkGrey}
              isHoverable
            />
          </Popable>
        )}
        {documentId && (
          <Popable
            numberOfLines={2}
            backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
            style={[
              {
                top: 30,
                zIndex: 20,
                maxWidth: 300,
              },
            ]}
            content={
              documents.find((u) => u?.id == documentId)?.title
                ? "Access to document"
                : "No access to document"
            }
            action="hover"
            position="left"
          >
            <AppIcon
              icon={
                documents.find((u) => u?.id == documentId)?.title
                  ? AppAssets.icons?.notes
                  : AppAssets?.icons.noAccess
              }
              isHoverable
              color={currentTheme?.theme?.darkGrey}
              style={{
                fontSize: currentTheme?.theme?.extra_small_font_size,
                fontWeight: "bold",
                color: currentTheme?.theme?.darkGrey,
                marginLeft: 5,
                textDecorationColor: currentTheme?.theme?.darkGrey,
                marginRight: 15,
              }}
            />
          </Popable>
        )}

        <Popable
          numberOfLines={2}
          backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
          style={[
            {
              top: 30,
              zIndex: 20,
              maxWidth: 300,
            },
          ]}
          content={messages?.length > 0 ? "Export Chat" : "Empty Chat"}
          action="hover"
          position="left"
        >
          <AppIcon
            isClickable={messages?.length > 0}
            onPress={createMessagesExportFile}
            color={
              messages?.length > 0
                ? currentTheme?.theme?.darkGrey
                : currentTheme?.theme?.mediumGrey
            }
            icon={AppAssets?.icons?.export}
            isHoverable
          />
        </Popable>

        {/* )} */}
      </View>
    );
  }, [
    planningExecution,
    onSelectedTopicsChange,
    JSON.stringify(selectedTopics),
    JSON.stringify(topics),
    JSON.stringify(primaryAgent),
    JSON.stringify(messages),
    isLargeScreen(),
    isMobileScreen(),
    allowStop,
    isAIStreaming,
    totalSteps,
    activeStep,
    agentHosting,
    JSON.stringify(chatObject),
  ]);

  const chatNameComponent = useMemo(() => {
    const language =
      chatObject?.language && chatObject?.language !== "def"
        ? ` - ${
            state?.languagesConfig?.find((u) => u?.id == chatObject?.language)
              ?.name
          }
          `
        : "";
    return (
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginRight: 20,
          flex: "auto",
          flexWrap: "wrap",
          width: "-webkit-fill-available",
          marginTop: -2,
        }}
      >
        <AppText
          style={{
            marginHorizontal: 10,
            width: "-webkit-fill-available",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            flex: 0.7,
            fontSize: currentTheme?.theme?.large_font_size,
          }}
          showTypingEffect
          typingSpeed={10}
          wrapperStyle={{
            marginRight: 20,
            flex: 1,
          }}
          fontWeight="bold"
        >{`${chatObject?.name}`}</AppText>
      </View>
    );
  }, [
    JSON.stringify(chatObject),
    state?.languagesConfig,
    isLargeScreen(),
    messages?.length,
    getActiveWorkspace()?.subscriptionType,
  ]);
  const coreChatView = useMemo(() => {
    return (
      ((primaryAgent?.icon && agentImage) ||
        !primaryAgent?.icon ||
        !isConnectedToCloud()) && (
        <AppQuantumChat
          cursor={cursor}
          disableEditingFeedback={!canInteractWithChat}
          allowStop={allowStop}
          agentDefaultIcon={agentImage || require("../../assets/favicon.png")}
          sendOnEnter
          showLoading={false}
          onCopy={handleCopy}
          renderMarkdown
          loadEarlier={allMessagesLoaded}
          messages={messages}
          setMessages={setMessages}
          showAgentName={forceAgentsName || primaryAgent?.showAgentName}
          coder={primaryAgent?.mode === "coder" || forceAgentsName}
          noDelay={true}
          requiresApproval={
            planningExecution != "planning_requires_approval" ||
            planningExecution != "step_requires_approval"
          }
          sendApprovalMessage={(msg, id) => {
            onSendEvent(msg);
            updatePlanApprovalState(id);
          }}
          onSendEvent={onSendEvent}
          handleShowSourcesDetails={handleShowSourcesDetails}
          user={{
            id: user?.id,
            name: user?.username,
          }}
          chatStyle={{
            height: height - 90,
          }}
          inverted={false}
          showUserAvatar
          messagesContainerStyle={{
            marginTop: 0,
          }}
          hideReasoning={
            primaryAgent?.hideReasoning == true &&
            _baseModels?.find((u) => u?.id == primaryAgent?.llmBaseModel)
              ?.reasoner == true &&
            chatObject?.handedOffToHuman != true
          }
          showCodeInExecution={primaryAgent?.showCodeInExecution != false}
          chatid={chatObject?.id}
          allowFeedback={primaryAgent?.allowFeedback}
          handleFeedback={handleFeedback}
          listenToAudio={listenToAudio}
          maxComposerHeight={60}
          composerHeight={60}
          sortOrder="asc"
          placeholderDisabled="The agent is responding..."
          isComposerDisabled={isAIStreaming}
          allowUserToTypeWhileGeneratingResponse={!isAIReplyingOtherUsers}
          onCancel={onCancelGeneration}
          inputText={inputText}
          setInputText={setInputText}
          renderWithVanillaInput={false}
          onLoadEarlier={onLoadEarlier}
          S3downloadUrlRequest={S3downloadUrlRequest}
          workspaceid={workspaceid}
          showDuration={primaryAgent?.showTimeForResponse}
          showRoutedModel={primaryAgent?.showRoutedModel}
          showSplash={primaryAgent?.showSplashWhenEmpty}
          splashTitle={primaryAgent?.messageOnLaunch}
          showLanguage={primaryAgent?.showDetectedLanguage}
          showProcessingMetadata={true}
          rlhf={
            chatObject?.visibility === "private" ||
            chatObject?.visibility === "widget"
          }
          plannerMode={primaryAgent?.mode == "planner"}
          isLastMessageEmpty={isLastMessageEmpty}
          customChartingConfig={getActiveWorkspace()?.customChartingConfig}
          isChatEmpty={messages?.length == 0}
          onImageSelected={onImageSelected}
          selectedImageKey={selectedImageKey}
          isSpeechGettingProcessed={isSpeechGettingProcessed}
          updateTextForSpeech={updateTextForSpeech}
          showTextToSpeech={primaryAgent?.allowAudiosGeneration}
          textToDisplayWhileLoading=""
        >
          <ChatWebInput
            createMessagesExportFile={createMessagesExportFile}
            isExportVisible={messages?.length > 0}
            isPlaying={isPlaying}
            isSpeechGettingProcessed={isSpeechGettingProcessed}
            text={inputText}
            setText={setInputText}
            isStreaming={
              (isAIStreaming || planningExecution == "step_requires_desktop") &&
              planningExecution != "planning_requires_approval" &&
              planningExecution != "step_requires_approval"
            }
            isPlannerAcceptingFeedback={isFeedbackOnPlanAllowed}
            onCancel={onCancelGeneration}
            onSend={onSendEvent}
            stopAudio={stopAudio}
            allowStop={allowStop}
            isLastMessageEmpty={isLastMessageEmpty}
            showWidgetChatsHistory={showWidgetChatsHistory}
            canInteractWithChat={canInteractWithChat}
            isChatEmpty={messages?.length == 0}
            primaryAgentId={primaryAgent?.id}
            forcePlannerStop={chatObject?.forcePlannerStop}
            handedOffToHuman={chatObject?.handedOffToHuman}
            quickQuestions={primaryAgent?.quickQuestions
              ?.split(";")
              ?.map((u) => u?.trim()?.replace(/\s+/g, " "))}
            allowImagesUpload={
              primaryAgent?.allowImagesUpload && agentHosting?.type != "ollama"
            }
            allowAudiosUpload={
              primaryAgent?.allowAudiosUpload && agentHosting?.type != "ollama"
            }
            allowVideosUpload={
              primaryAgent?.allowVideosUpload && agentHosting?.type != "ollama"
            }
            isAutoReplyMode={
              primaryAgent?.autoVoiceMode && agentHosting?.type != "ollama"
            }
            allowFileUpload={
              (primaryAgent?.hasCode || primaryAgent?.allowDocsUpload) &&
              agentHosting?.type != "ollama"
            }
            allowCodeUpload={
              primaryAgent?.allowDocsUpload &&
              primaryAgent?.mode == "coder" &&
              agentHosting?.type != "ollama"
            }
            allowMiscFileTypes={
              ((primaryAgent?.hasCode && primaryAgent?.mode == "coder") ||
                (primaryAgent?.mode == "planner" &&
                  primaryAgent?.allowDocsUpload)) &&
              agentHosting?.type != "ollama"
            }
            onImageUploaded={onImageUploaded}
            onAudioUploaded={onAudioUploaded}
            onFileUploaded={onFileUploaded}
            fileUrl={fileUrl}
            setFileUrl={setFileUrl}
            imageUrl={imageUrl}
            setImageUrl={setImageUrl}
            audioUrl={audioUrl}
            setAudioUrl={setAudioUrl}
            onVideoUploaded={onVideoUploaded}
            videoUrl={videoUrl}
            setVideoUrl={setVideoUrl}
            placeholder={
              selectedImageKey
                ? "How would you like to refine the image generated?"
                : "Ask me anything..."
            }
            onFilesUploaded={onFilesUploaded}
            fileUrls={fileUrls}
            setFileUrls={setFileUrls}
            isPlanner={primaryAgent?.mode == "planner"}
            planningExecution={planningExecution}
          />
        </AppQuantumChat>
      )
    );
  });
  const _treeView = useMemo(() => {
    const headerComponents = [
      <ToothFairySupportButton />,
      <Popable
        numberOfLines={2}
        backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
        style={[
          {
            top: 30,
            zIndex: 20,
            maxWidth: 300,
          },
        ]}
        content={"New Chat"}
        action="hover"
        position="bottom"
      >
        <div className="start_chat">
          <AppIcon
            icon={AppAssets.icons.chatIcon}
            color={currentTheme?.theme?.darkGrey}
            isHoverable
            isClickable
            onPress={() => {
              !creationOfNewChatInProgress && setDialogActionOnTree("NEW_CHAT");
            }}
            wrapperStyle={{
              marginRight: 10,
              marginLeft: 7,
              marginTop: 1,
            }}
          />
        </div>
      </Popable>,
      isConnectedToCloud() && (
        <Popable
          numberOfLines={2}
          backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
          style={[
            {
              top: 30,
              zIndex: 20,
              maxWidth: 400,
            },
          ]}
          content={"Go to Hub"}
          action="hover"
          position="bottom"
        >
          <div className="upload_docs">
            <AppIcon
              icon={AppAssets.icons.notes}
              color={currentTheme?.theme?.darkGrey}
              size={20}
              isHoverable
              isClickable
              onPress={() => {
                history.push(
                  `/workspaces/${getActiveWorkspace()?.id}/mrc_contents`
                );
              }}
            />
          </div>
        </Popable>
      ),

      isConnectedToCloud() && (
        <View
          style={{
            flexDirection: "row",
          }}
        >
          <AppText
            style={{
              fontWeight: "bold",
            }}
            color={currentTheme?.theme?.darkGrey}
            wrapperStyle={{
              marginHorizontal: 10,
            }}
          >
            |
          </AppText>
          <Popable
            numberOfLines={2}
            backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
            style={[
              {
                top: 30,
                zIndex: 20,
                maxWidth: 400,
              },
            ]}
            content={"Hire Agent"}
            action="hover"
            position="bottom"
          >
            <AppIcon
              icon={AppAssets.icons.hire}
              color={currentTheme?.theme?.darkGrey}
              isHoverable
              isClickable
              onPress={() => {
                history.push(
                  `/workspaces/${
                    getActiveWorkspace()?.id
                  }/settings/roles_settings/hire`
                );
              }}
            />
          </Popable>
        </View>
      ),
    ].filter(Boolean);

    return (isTreeDataLoading || _coreTreeViewData === null) && !isCollapsed ? (
      <LoadingPlaceholder
        style={{
          padding: 10,
          minWidth: 330,
        }}
        visible
        caption="Loading..."
      />
    ) : (
      <AppTreeView
        headerComponents={headerComponents}
        secondaryActionTitle={
          isUserContentAdmin() &&
          isConnectedToCloud() &&
          getActiveWorkspace()?.subscriptionType != "base"
            ? showWidgetChatsHistory
              ? "Internal"
              : "External"
            : null
        }
        secondaryActionTitlePopup={
          isUserContentAdmin() &&
          isConnectedToCloud() &&
          getActiveWorkspace()?.subscriptionType != "base"
            ? showWidgetChatsHistory
              ? "Show chats from internal users"
              : "Show chats from external users"
            : null
        }
        indent={20}
        secondaryActionCallback={handleClickOnWidgetChatsHistory}
        allowParentEdit={false}
        allowParentAction={true}
        onParentActionClick={handleParentActionClick}
        requireNormalisation={false}
        showCollapseTree={true}
        title={" "}
        treemode="CHATS"
        preventSortingByName={true}
        foldersData={[..._coreTreeViewData]}
        selectedNode={selectedNode}
        handleClickOnNode={handleClickOnNode}
        deleteNode={deleteNode}
        setDialogActionOnTree={setDialogActionOnTree}
        isEmpty={_coreTreeViewData?.length === 0}
        onDrop={onDrop}
        initialOpen={false}
        minWidth={330}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        showIconsOnSelection={!showWidgetChatsHistory}
        onMove={onMove}
        deleteAction="DELETE_NODE"
        editLeafAction="EDIT_CHAT"
        editLeafParentAction="EDIT_CHAT"
        heightOffset={isMoreToLoad ? 145 : 125}
        disableTFDrag={true}
      />
    );
  }, [
    _coreTreeViewData?.map((u) => {
      return {
        id: u?.id,
        name: u?.name,
        description: u?.description || "No description available",
      };
    }),
    isTreeDataLoading,
    isCollapsed,
    creationOfNewChatInProgress,
    getActiveWorkspace()?.id,
    currentTheme?.theme?.darkGrey,
  ]);
  const _actionsChoice = () => {
    return (
      <ToothFairyResponsiveOptionsModal
        isModalOpen={isModalOptionsOpen}
        setIsModalOpen={setIsModalOptionsOpen}
        modalTitle={"Actions"}
        height={300}
      >
        <ToothFairyClickableOption
          leftIcon={Utility.mapAgentTypeWithIcon(primaryAgent, AppAssets)}
          onPress={() => {
            if (creationOfNewChatInProgress) return;
            setIsModalOptionsOpen(false);
            setDialogActionOnTree("NEW_CHAT");
          }}
        >
          New Chat
        </ToothFairyClickableOption>
      </ToothFairyResponsiveOptionsModal>
    );
  };
  const _coreHeaderComponent = useMemo(() => {
    return (
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginTop: 5,
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <ToothFairySupportButton />

          <></>
        </View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginRight: 10,
          }}
        ></View>
      </View>
    );
  }, [
    setDialogActionOnTree,
    isLargeScreen(),
    JSON.stringify(state?.agents),
    JSON.stringify(messages),
    getActiveWorkspace()?.id,
    planArtifacts?.length,
  ]);
  return (
    <AppBaseScreen
      isScrollable={true}
      contentContainerStyle={{
        overflow: "auto",
        flex: 1,
      }}
    >
      <AppJoyRide
        handleCallback={(e) => {
          if (user?.userHelperPreferences?.knowledgeHubVisited) {
            if (e?.action == "next" && e?.index == 0) {
              updateUserHelperPreferences(user, { chatsTourCompleted: true });
              formRef?.current?.resetForm();
              setTreeViewActionContext("NEW_CHAT");
              setShowModal(true);
            }
          } else if (!user?.userHelperPreferences?.knowledgeHubVisited)
            if (e?.action == "next" && e?.index == 0) {
              history.push(
                `/workspaces/${getActiveWorkspace()?.id}/mrc_contents`
              );
              updateUserHelperPreferences(user, { knowledgeHubVisited: true });
            }
        }}
        run={
          user?.userHelperPreferences?.knowledgeHubVisited != true ||
          user?.userHelperPreferences?.chatsTourCompleted != true
        }
        steps={
          user?.userHelperPreferences?.knowledgeHubVisited
            ? steps_second_interaction
            : steps_first_interaction
        }
        spotlightClicks={true}
      />
      <View
        style={{
          paddingHorizontal: 20,
          paddingTop: 5,
          paddingBottom: 0,
          minWidth: minAppWidth(),
          flex: 1,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            flexWrap: "wrap",
            maxWidth: isMobileScreen() && "100%",
          }}
        >
          {_coreHeaderComponent}
        </View>
        <View
          style={{
            flexDirection: "row",
            flex: 1,
            zIndex: -1,
          }}
        >
          <View
            style={{
              flexDirection: "column",
              height: "100%",
            }}
          >
            {isConnectedToCloud() && _treeView}
            {isMoreToLoad &&
              !isTreeDataLoading &&
              _coreTreeViewData?.length > 0 &&
              !isCollapsed && (
                <AppText
                  wrapperStyle={{
                    alignSelf: "center",
                    marginTop: 5,
                  }}
                  isClickable
                  style={{
                    color: currentTheme?.theme?.primary,
                  }}
                  fontWeight="bold"
                  onPress={async () => {
                    setIsChatHistoryLoaded(false);
                    await loadChats(showWidgetChatsHistory);
                    setIsChatHistoryLoaded(true);
                  }}
                >
                  Load more
                </AppText>
              )}
          </View>

          {!isConnectedToCloud() ? (
            !isElectronRunning() ? (
              <>{coreChatView}</>
            ) : (
              <AppPlaceholderView
                accessibilityLabel="chat-placeholder"
                wrapperStyle={{
                  width: 400,
                  height: 200,
                  marginVertical: "auto",
                  marginHorizontal: "auto",
                }}
                size={30}
                icon={AppAssets.icons.orbit}
                mainCaption={"ChatSubscriptionErrorMainCaption"}
                subCaption={"ChatSubscriptionErrorSubCaption"}
              />
            )
          ) : (isLoading || !chatObject?.name) &&
            chatId &&
            isConnectedToCloud() ? (
            <LoadingPlaceholder
              style={{
                padding: 10,
              }}
              visible
              caption="Loading chat"
            />
          ) : chatId ? (
            <View style={{ flex: 1, minWidth: minAppWidth() - 40, zIndex: -1 }}>
              <View
                style={{
                  zIndex: 3,
                  flexDirection: "row",
                  borderBottomColor: currentTheme?.theme?.darkGrey,
                  borderBottomWidth: 0.5,
                  marginBottom: 5,
                }}
              >
                {chatNameComponent}
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingVertical: 0,
                    zIndex: 3,
                    // minHeight: 78,
                    flexWrap: "wrap",
                    paddingBottom: isMobileScreen() && 10,
                  }}
                >
                  {topicSelectionComponent}
                </View>
              </View>
              {coreChatView}
            </View>
          ) : (
            <AppPlaceholderView
              accessibilityLabel="chat-placeholder"
              wrapperStyle={{
                width: 300,
                height: 200,
                marginVertical: "auto",
                marginHorizontal: "auto",
              }}
              size={30}
              icon={AppAssets.icons.orbit}
              mainCaption={
                chatId ? "ChatDoesNotExistCaption" : "SelectChatCaption"
              }
              subCaption={
                chatId ? "ChatDoesNotExistSubCaption" : "SelectChatSubCaption"
              }
            />
          )}
        </View>
      </View>
      {_coreModalView}
      {_coreSourcesModelView}
      {_plannerModalView}
      {_artifactsModalView}
      {_actionsChoice()}
    </AppBaseScreen>
  );
};

export default ChatsScreenView;
